import React, { useState, useEffect } from "react";
import axios from "axios";
import { BsBell } from "react-icons/bs";
import { AiFillExclamationCircle } from "react-icons/ai";
import { VscBellDot } from "react-icons/vsc";
import { Link } from "react-router-dom";
import "./iconNotifi.css";

const IconNotifi = () => {
  const [isHovering, setIsHovering] = useState(false);
  const [alertMessage, setAlertMessage] = useState([]);
  const [alertDocument, setAlertDocument] = useState([]);
  const [hasData, setHasData] = useState(false);
  useEffect(() => {
    setAlertMessage([]);
    setAlertDocument([]);
    const fetchData = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_ALERTS_API}`);
        // Mapeo de alertMessage
        const usersToUpdate = res.data.entitiesToUpdate.map((user) => {
          const id = user.dni || user.cuit;
          const typeDocument =
            user.entityType === "Persona Humana" ? "DNI" : "CUIT";
          return {
            id,
            status: user.status,
            updateAt: user.updateAt,
            currentDate: user.expirestAt,
            entityType: user.entityType,
            typeDocument,
            identify: user.identify,
            type: user.risk,
          };
        });
        setAlertMessage(usersToUpdate);

        // Mapeo de alertDocument
        const alerts = res.data.alerts;
        setAlertDocument(alerts);

        if (
          res.status === 200 &&
          (usersToUpdate.length > 0 || alerts.length > 0)
        ) {
          setHasData(true);
        }
      } catch (err) {}
    };

    fetchData();
  }, []);

  const handleMouseOver = () => {
    setIsHovering(!isHovering);
  };

  return (
    <div className="box-bell">
      <div className="box-icon-text-animation" onClick={handleMouseOver}>
        {hasData ? (
          <VscBellDot className="iconBellNotifi" />
        ) : (
          <BsBell className="iconBellNotifi" />
        )}
      </div>
      {isHovering && (
        <div className="buble-notification">
          <div className="box-tittle-notifi">
            <p className="tittle-notifi">Notificaciones</p>
          </div>
          <div className="list_notifi">
            {/* Sección para alertMessage */}
            {alertMessage.map((item, index) => (
              <div className="notifi-red" key={index}>
                {item.status !== "Baja" && (
                  <Link to="/alertas">
                    <div className="box-notifi-display">
                      <div className="box-icon-red">
                        <AiFillExclamationCircle className="icon-alert-notifi" />
                      </div>
                      <div className="message-notifi">
                        <p className="message-alert-notifi">
                          Atención, el usuario ({item.identify}) {item.id}
                          <br />
                          necesita una actualización
                        </p>
                      </div>
                    </div>
                  </Link>
                )}
              </div>
            ))}

            {/* Sección para alertDocument */}
            {alertDocument.map((item, index) => (
              <div className="notifi-red" key={index}>
                {item.status !== "Baja" && (
                  <Link to="/alertas">
                    <div className="box-notifi-display">
                      <div className="box-icon-red">
                        <AiFillExclamationCircle className="icon-alert-notifi" />
                      </div>
                      <div className="message-notifi_document">
                        <p className="message-alert-notifi">
                          Atención, el documento ({item.entityType}) del usuario{" "}
                          {item.identify} necesita una actualización
                        </p>
                      </div>
                    </div>
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default IconNotifi;
